import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiDownload } = FiIcons;

const RecentInvoices = () => {
  const invoices = [
    {
      id: 'INV-001',
      client: 'TechCorp Ltd',
      amount: '$2,500',
      status: 'Paid',
      date: '2024-01-15'
    },
    {
      id: 'INV-002',
      client: 'StartupXYZ',
      amount: '$1,800',
      status: 'Pending',
      date: '2024-01-14'
    },
    {
      id: 'INV-003',
      client: 'E-commerce Plus',
      amount: '$3,200',
      status: 'Overdue',
      date: '2024-01-10'
    },
    {
      id: 'INV-004',
      client: 'Digital Agency',
      amount: '$2,100',
      status: 'Paid',
      date: '2024-01-12'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Paid': return 'bg-green-100 text-green-800';
      case 'Pending': return 'bg-yellow-100 text-yellow-800';
      case 'Overdue': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-soft">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-800">Recent Invoices</h3>
        <button className="text-primary-600 hover:text-primary-700 text-sm font-medium">
          View All
        </button>
      </div>
      
      <div className="space-y-4">
        {invoices.map((invoice, index) => (
          <motion.div
            key={invoice.id}
            className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h4 className="font-medium text-gray-800">{invoice.id}</h4>
                <span className="font-semibold text-gray-800">{invoice.amount}</span>
              </div>
              <p className="text-sm text-gray-600 mt-1">{invoice.client}</p>
              <div className="flex items-center justify-between mt-2">
                <span className="text-xs text-gray-500">{invoice.date}</span>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(invoice.status)}`}>
                  {invoice.status}
                </span>
              </div>
            </div>
            
            <div className="flex items-center space-x-2 ml-4">
              <button className="p-2 hover:bg-gray-200 rounded-lg transition-colors duration-200">
                <SafeIcon icon={FiEye} className="w-4 h-4 text-gray-600" />
              </button>
              <button className="p-2 hover:bg-gray-200 rounded-lg transition-colors duration-200">
                <SafeIcon icon={FiDownload} className="w-4 h-4 text-gray-600" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default RecentInvoices;